var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.96 19.5854C17.4902 19.5854 17.92 19.1556 17.92 18.6254C17.92 18.0952 17.4902 17.6654 16.96 17.6654C16.4298 17.6654 16 18.0952 16 18.6254C16 19.1556 16.4298 19.5854 16.96 19.5854Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 19.5854C13.3302 19.5854 13.76 19.1556 13.76 18.6254C13.76 18.0952 13.3302 17.6654 12.8 17.6654C12.2698 17.6654 11.84 18.0952 11.84 18.6254C11.84 19.1556 12.2698 19.5854 12.8 19.5854Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11998 5.50546C5.47344 5.50546 5.75998 5.21893 5.75998 4.86546C5.75998 4.512 5.47344 4.22546 5.11998 4.22546C4.76652 4.22546 4.47998 4.512 4.47998 4.86546C4.47998 5.21893 4.76652 5.50546 5.11998 5.50546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 17.6654C17.6 17.6654 13.5462 17.6654 12.7069 17.6654C11.6125 17.6654 11.4518 17.1073 11.2595 16.3774L8.70112 6.04808C8.47104 5.27272 8.14687 4.86536 7.25247 4.86536C7.25247 4.86536 5.7312 4.86536 5.12 4.86536",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59998 9.02551H19.52L17.2189 15.1055H11.0749",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.06543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartIcon);
export default __webpack_public_path__ + "static/media/shopping-cart-icon.00a5264d588909250529a345edf756fb.svg";
export { ForwardRef as ReactComponent };